export default __webpack_public_path__ + "static/media/card-bottom4.aee0850d.webp";